import React from 'react'

const StatsCard = ({ title, value, bg, icon }) => {
    return (
        <div className={`rounded-2xl bg-${bg ? bg : 'white'} p-4 flex items-center justify-between gap-2`}>
            <div className="">
                <p className='text-black font-quicksand text-[13px] font-medium' >{title}</p>
                <h2 className='text-black font-roboto-mono text-[20px] font-bold' >
                    {value}
                </h2>
            </div>
            <div className="img w-[30%]">
                <img src={icon} className='w-full h-full' />
            </div>
        </div>
    )
}

export default StatsCard
